/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placeholder_BodyInputs */

const cs_placeholder_body = /** @type {(inputs: Placeholder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obrazovka je připravená — napojení na GraphQL přijde po doméně.`)
};

const en_placeholder_body = /** @type {(inputs: Placeholder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Screen is ready — GraphQL wiring comes per domain.`)
};

/**
* | output |
* | --- |
* | "Screen is ready — GraphQL wiring comes per domain." |
*
* @param {Placeholder_BodyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const placeholder_body = /** @type {((inputs?: Placeholder_BodyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeholder_BodyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placeholder_body(inputs)
	return cs_placeholder_body(inputs)
});